<template>
  <div
    class="content-tab-wrap"
    :class="{ 'flex-shrink': toShowShopTypeData.state !== 0 }"
    @touchstart="contentTouchstart"
    @touchmove="contentTouchmove"
    @touchend="contentTouchend"
  >
    <div class="tab-controls-group">
      <div class="tab-row">
        <div
          class="tab"
          :class="{ active: currentIndex === 0 }"
          @click="changeCurIndex(0)"
        >
          <div class="text-wrap">智能台灯体验店</div>
        </div>
        <div
          class="tab"
          :class="{ active: currentIndex === 1 }"
          @click="changeCurIndex(1)"
        >
          <div class="text-wrap">钢琴灯体验店</div>
        </div>
      </div>
      <div class="border-row">
        <div
          class="border"
          :class="{ 'moving-end': movingEnd }"
          :style="{
            width: `${controllsBorderData.curWidth}px`,
            transform: `translateX(${controllsBorderData.curX}px)`,
          }"
          @transitionend="handleTouchMovingEnd"
        ></div>
      </div>
    </div>
    <div class="tab-wrap">
      <div
        class="tab-inner-wrap"
        :style="{
          transform: `translateX(${tabTransformData}px)`,
        }"
        :class="{ 'moving-end': movingEnd }"
      >
        <div class="tab">
          <!-- <shop-content
            :state="shopTypeData[1].state"
            :storeList="shopTypeData[1].storeList"
            :isGeoFlag="isGeoFlag"
          ></shop-content> -->
          <slot name="tab1"></slot>
        </div>
        <div class="tab">
          <!-- <shop-content
            :state="shopTypeData[2].state"
            :storeList="shopTypeData[2].storeList"
            :isGeoFlag="isGeoFlag"
          ></shop-content> -->
          <slot name="tab2"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import shopContent from "./shopContent.vue";
export default {
  name: "content-tab",
  props: ["data", "isGeoFlag", "currentIndex"],
  model: {
    prop: "currentIndex",
    event: "change",
  },
  data() {
    return {
      layoutData: {
        wrapBoxWidth: 0, //外框宽度
        innerBoxWidth: 0, //内容宽度
        tabWidth: 0, // 控制tab标签宽度
        textWidthList: [], // 各个标签内部宽度
      },
      contentTouchmoveData: {
        startX: 0, // 触摸开始X
        movingDistance: 0, // 移动距离
      },
      movingEnd: false, //移动结束
      shopTypeData: this.$props.data,
    };
  },
  methods: {
    // 初始化布局数据
    changeCurIndex(n) {
      this.$emit("change", n);
    },
    initStyleAfterReady() {
      const wrapBoxWidth = this.$el.clientWidth;
      this.layoutData.innerBoxWidth =
        this.$el.querySelector(".tab-wrap").clientWidth;
      // console.log(this.$el);
      this.layoutData.wrapBoxWidth = wrapBoxWidth;
      this.layoutData.tabWidth = this.$el.querySelector(
        ".tab-controls-group .tab"
      ).clientWidth;
      this.layoutData.textWidthList = Array.from(
        this.$el.querySelectorAll(".text-wrap")
      ).map((e) => e.clientWidth);
    },
    contentTouchstart(e) {
      const x = e.touches[0].clientX;
      this.contentTouchmoveData.startX = x;
    },
    contentTouchmove(e) {
      const x = e.touches[0].clientX;
      const movDis = x - this.contentTouchmoveData.startX;
      if (this.currentIndex === 0 && movDis > 0) {
        //不可左移
        return;
      } else if (
        this.currentIndex === this.layoutData.textWidthList.length - 1 &&
        movDis < 0
      ) {
        //不可右移
        return;
      }
      this.contentTouchmoveData.movingDistance = movDis;
    },
    contentTouchend(e) {
      if (
        this.contentTouchmoveData.movingDistance === 0 ||
        Math.abs(
          this.contentTouchmoveData.movingDistance /
            this.layoutData.wrapBoxWidth
        ) < 0.3
      ) {
        console.log("pass");
      } else {
        this.changeCurIndex(
          this.currentIndex +
            (this.contentTouchmoveData.movingDistance < 0 ? 1 : -1)
        );
        // this.currentIndex +=
        //   this.contentTouchmoveData.movingDistance < 0 ? 1 : -1;
      }
      this.contentTouchmoveData.movingDistance = 0;
      this.movingEnd = true;
    },
    handleTouchMovingEnd(e) {
      this.movingEnd = false;
    },
  },
  computed: {
    toShowShopTypeData() {
      return this.shopTypeData[this.currentIndex + 1];
    },
    // 标签栏下方横条偏移量
    controllsBorderData() {
      const { tabWidth, wrapBoxWidth, textWidthList } = this.layoutData;
      const textWidth = textWidthList[this.currentIndex];
      const borderWidth = textWidth * 0.6;
      const movDis = -this.contentTouchmoveData.movingDistance;
      return {
        curX:
          (tabWidth - borderWidth) / 2 +
          tabWidth * this.currentIndex +
          (movDis / wrapBoxWidth) * tabWidth,
        curWidth: borderWidth,
      };
    },

    // 内容偏移量
    tabTransformData() {
      return -(
        this.layoutData.innerBoxWidth * this.currentIndex +
        -this.contentTouchmoveData.movingDistance
      );
    },
  },
  mounted() {
    this.initStyleAfterReady();
  },
  components: { shopContent },
  created() {
    console.log(this.$slots);
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/index.scss";
.content-tab-wrap {
  background-color: #fff;
  border-radius: 9rem / $base;
  min-height: 264rem / $base;

  padding: 0 22rem / $base 18rem / $base;
  width: 100%;
  box-sizing: border-box;

  flex: 9;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;

  &.flex-shrink {
    flex: unset;
  }
  .tab-controls-group {
    box-sizing: border-box;
    width: 100%;
    padding: 20rem / $base 43rem / $base;

    $active-color: #f4ce98;

    text-align: center;
    white-space: nowrap;
    .tab-row {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      .tab {
        flex-basis: 10rem;
        flex-grow: 1;
        color: $color-text-grey;
        .text-wrap {
          font-size: 29rem / $base;
          margin: 0 auto;
          width: min-content;
          font-weight: bolder;
        }
        &.active {
          color: $active-color;
        }
      }
    }
    .border-row {
      width: 100%;
      .border {
        margin-top: 5rem / $base;
        display: block;
        border-bottom: 10rem / $base $active-color solid;
      }
    }
  }
  .tab-wrap {
    width: 100%;
    overflow: hidden;
    .tab-inner-wrap {
      width: 200%;
      height: 100%;
      display: flex;
      flex-flow: row nowrap;
    }
    .tab {
      flex: 50%;
      // display: table-cell;
      // width: 100%;
      overflow: hidden;
    }
  }
  .moving-end {
    transition: 0.5s all ease;
  }
}
</style>
